<i18n src="./resources/locales.json"></i18n>

<template>
  <div class="conversation-side-panel">
    <SmsSearchInput :placeholder="$t('search.conversationText')" @input="val => (keyword = val)" />

    <v-list class="conversation-items custom-scrollbar" v-show="displayedConversations.length">
      <SmsConversationItem
        v-for="conversation in displayedConversations"
        :key="conversation.conversationKey"
        :conversation="conversation"
        @delete-conversation="handleConversationDelete"
      />
    </v-list>

    <SmsEmptyMessage
      v-if="!displayedConversations.length"
      :dark="$vuetify.theme.dark"
      :message="getEmptyConversationsMessage"
    />

    <SmsConfirmationDialog
      ref='confirmationDialog'
      @confirm-action='finalizeConversationDelete'></SmsConfirmationDialog>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import SmsSearchInput from '@/components/SmsSearchInput/SmsSearchInput';
import SmsConversationItem from '@/components/SmsConversationItem';
import SmsEmptyMessage from '@/components/SmsEmptyMessage/SmsEmptyMessage';
import ToastMixin from '@/mixins/ToastMixin.js';
import SmsConfirmationDialog from '@/components/SmsConfirmationDialog/SmsConfirmationDialog.vue';

export default {
  name: 'SmsConversationsSidePanel',
  components: { SmsConfirmationDialog, SmsConversationItem, SmsSearchInput, SmsEmptyMessage },
  mixins: [ToastMixin],

  data() {
    return {
      keyword: '',
      isLoading: false,
      commonNumbers: []
    };
  },

  computed: {
    ...mapGetters('conversationsV2', [
      'allConversations',
      'activeConversation',
      'getConversationById',
      'getConversationsContainingMessageTextOrContactName'
    ]),
    ...mapState('user', { userId: state => state.userId }),

    displayedConversations() {
      return this.keyword ? this.getConversationsContainingMessageTextOrContactName(this.keyword) : this.allConversations;
    },

    getEmptyConversationsMessage() {
      return this.keyword
        ? this.$t('sidePanel.conversation.emptySearch', { keyword: this.keyword })
        : this.$t('sidePanel.conversation.recent');
    }
  },

  methods: {
    ...mapActions('conversationsV2', ['setActiveConversationId', 'deleteConversationByConversationId']),
    ...mapActions('contactsV2', ['retrieveAvatars']),

    openConversation(conversation) {
      this.$root.$emit('change-conversation');
      this.$root.$emit('close-sidebar');
      if (conversation) {
        this.setActiveConversationId(conversation.conversationId);
      }
    },

    filterConversations() {
      if (this.keyword) {
        return this.allConversations.filter(item => {
          return item.lastMessageText.includes(this.keyword) || this.filterByContact(item);
        });
      }
      return [];
    },

    filterByContact(conversation) {
      const filterParticipants = conversation.participants.filter(item => {
        return (
          this.$store.getters['filters/getMessages'].find(number => number.phoneNumberContact === item.number) ||
          (item.firstName && item.firstName.includes(this.keyword)) ||
          (item.lastName && item.lastName.includes(this.keyword)) ||
          item.number.includes(this.keyword)
        );
      });
      return filterParticipants.length > 0;
    },
    handleConversationDelete(conversation) {
      const { conversationId } = conversation;
      const confirmationText = `Are you sure you want to delete the conversation for ${conversationId}?`;
      const confirmationData = { conversation: { conversationId } };
      const confirmationTitle = "Confirm conversation delete"
      this.$refs.confirmationDialog.open({ confirmationData, confirmationText,
        confirmationTitle });
    },
    finalizeConversationDelete({ conversation } ) {
      const { conversationId } = conversation;
      this.deleteConversationByConversationId({ conversationId }).then(response => {
        if (!response.successful) {
          console.error(`Failed to delete conversation by conversationId: ${conversationId}.`);
          this.showError(response.responseMessage);
        }
        else {
          this.showSuccess(response.responseMessage);
        }
      });
    }
  },
  mounted() {
    const contacts = this.displayedConversations
      .map(convo => convo.contact)
      .filter(contact => contact.isAzureContact && contact.userId && !contact.avatar);
    this.retrieveAvatars(contacts);
  },
};
</script>
<style scoped>
.conversation-side-panel {
  height: 100%;
  display: grid;
  grid-template-rows: 40px auto;
}

.conversation-items {
  background: var(--v-surface-base);
  height: 100%;
  overflow: auto;
  position: relative;
  z-index: 1;
}
</style>
